import {useEffect, useState} from 'react';
import LearnMore from "./LearnMore";
import Alert from "../../views/NUI/Alert";
import { QUAL_STATUS } from "views/med/utils";
import onepass_model from "../../models/onepass_model";
import { useOnePassDiscount } from "../Hooks/discounts/useOnePassDiscount";
import { ONEPASS_FIRST_TIME_CODE } from "@iscr/constants";

export default function PriceUpdate({
    qual_status,
    cart: { MEDCONS_PRICE, MEDCONS_STD = app.site_status?.prs_mc['mc_std'] } = {},
    className = "mt-8",
    enable = true,
    onepassEligible,
    med_data,
}) {
    const disabled = (!enable || qual_status === QUAL_STATUS.CURRENT)

    const rejected =  [QUAL_STATUS.CONS_ONLY].includes(qual_status);
    const onepassDiscount = useOnePassDiscount()
    const [discountedPrice, setDiscountedPrice] = useState(MEDCONS_PRICE);
    const [discountedSingleScriptPrice, setDiscountedSingleScriptPrice] = useState(MEDCONS_STD);
        useEffect(() => {
            if (!disabled && onepassDiscount) {
                const discount = onepass_model.discountedPriceString(onepassDiscount, MEDCONS_PRICE)
                setDiscountedPrice(discount);
                const discountConfig = onepassDiscount.subsequent ? {conf : onepassDiscount.subsequent} : onepassDiscount;
                const discountSTD = onepass_model.discountedPriceString(discountConfig, MEDCONS_STD)
                setDiscountedSingleScriptPrice(discountSTD)
            }
        }, [onepassEligible, onepassDiscount, disabled, MEDCONS_PRICE, MEDCONS_STD]);

    if (disabled) return null;

    return (
        <Alert info className={className} header="Update">

                {rejected ? (
                    <>
                        <p>We can see you have not been approved for online prescriptions for this medication through InstantScripts.</p>
                        <p>
                            To access scripts for this medication in the future, you will need to
                            speak to one of our doctors via a Telehealth
                            Consultation.
                        </p>
                        <p>
                            The cost of your request today {
                                onepassDiscount && onepassEligible && onepass_model.isValidOnepassItem(med_data)
                                    ? `for being a OnePass member will be ${discountedPrice}} ${onepassDiscount.code === ONEPASS_FIRST_TIME_CODE ? ' for you first purchase' : ''}`
                                    : `will be $${MEDCONS_PRICE}`
                            } and includes a call with a doctor to
                            discuss your condition and determine the best
                            treatment.
                        </p>
                    </>
                ) : (
                    <>
                        <p>
                            The cost of your request today {
                                onepassDiscount&& onepassEligible && onepass_model.isValidOnepassItem(med_data)
                                    ? `for being a OnePass member is ${discountedPrice} ${onepassDiscount.code === ONEPASS_FIRST_TIME_CODE ? ' for you first purchase' : ''}`
                                    : `is $${MEDCONS_PRICE}`
                            } and includes a call with a doctor as well as any prescription issued.
                        </p>
                        <p>
                            If you’re approved for ongoing single script renewals for this medication, the cost will be reduced
                            {onepassDiscount && onepassEligible && onepass_model.isValidOnepassItem(med_data)
                                ? ` as a OnePass member to ${discountedSingleScriptPrice}`
                                : ` to $${MEDCONS_STD}`} for the next 12 months.
                        </p>
                    </>
                )}
                <LearnMore />
        </Alert>
    );
}
